import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Loader2, AlertTriangle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EmailPreviewDialog({ open, onOpenChange, subject, body, guestId, prospectId, toEmail }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!open) return;
    setData(null);
    axios.post(`${API}/email/preview`, { subject, body, guestId, prospectId })
      .then(r => setData(r.data))
      .catch(() => setData({ error: true }));
  }, [open]); // eslint-disable-line

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl p-0 overflow-hidden" data-testid="email-preview-dialog">
        <DialogHeader className="px-5 pt-4 pb-3 border-b border-stone-200">
          <DialogTitle className="text-[15px]">Email preview</DialogTitle>
          <DialogDescription className="text-[12px] text-stone-500">Exactly what the recipient will see — all merge tags resolved.</DialogDescription>
        </DialogHeader>
        {!data ? (
          <div className="h-[300px] grid place-items-center"><Loader2 className="w-5 h-5 animate-spin text-stone-400" /></div>
        ) : data.error ? (
          <div className="p-6 text-[13px] text-red-600">Preview failed — could not reach the server.</div>
        ) : (
          <div className="flex flex-col max-h-[75vh]">
            <div className="px-5 py-2.5 border-b border-stone-100 text-[12.5px] space-y-0.5 bg-stone-50">
              <div><span className="text-stone-400 inline-block w-16">From</span> {data.from || '—'}</div>
              {toEmail && <div><span className="text-stone-400 inline-block w-16">To</span> {toEmail}</div>}
              <div data-testid="preview-subject"><span className="text-stone-400 inline-block w-16">Subject</span> <span className="font-medium text-stone-900">{data.subject || '(no subject)'}</span></div>
            </div>
            {data.unresolved?.length > 0 && (
              <div data-testid="preview-unresolved-warning" className="px-5 py-2 bg-amber-50 border-b border-amber-200 text-[12px] text-amber-800 flex items-center gap-1.5">
                <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
                These tags could not be resolved and will appear literally: {data.unresolved.join(', ')}
              </div>
            )}
            <iframe title="email-preview" srcDoc={data.html} sandbox="" className="w-full flex-1 min-h-[380px] bg-white border-0" />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
